import React, { createContext, useReducer } from 'react';
import { useSelector } from 'react-redux';

import Reducer from '../reducer/reducer';

const Store = ({ state = {}, children }) => {
	const { DisableLazyLoad } = useSelector(
		({ featureSwitches }) => featureSwitches
	);

	if (DisableLazyLoad) {
		Object.entries(state).reduce(
			(acc, [key]) => ({
				...acc,
				[key]: true,
			}),
			{}
		);
	}

	const [contextState, dispatch] = useReducer(Reducer, state);

	return (
		<Context.Provider value={[contextState, dispatch]}>
			{children}
		</Context.Provider>
	);
};

export const Context = createContext({});
export default Store;
